import { Badge, Empty, List } from "antd";
import dayjs from "dayjs";
import _, { cloneDeep } from "lodash";
import { useContext } from "react";
import CustomPagination from "../../commons/components/CustomPagination";
import PrimaryButton from "../../commons/components/PrimaryButton/PrimaryButton";
import { AppTencentContext } from "../../contexts/ChatContext";
import "./styles.scss";

export const STATUS_CODE = {
  SUCCESS: 200,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
};

export enum MerchantNotificationEventName {
  MerchantAccountDeactivated = "MERCHANT_ACCOUNT_DEACTIVATED",
  MerchantStoreCreated = "MERCHANT_STORE_CREATED",
  MerchantStoreUpdated = "MERCHANT_STORE_UPDATED",
  ProductCreatedApproval = "PRODUCT_CREATION_APPROVAL",
  ProductEditApproval = "PRODUCT_EDIT_APPROVAL",
  ProductQuantityUpdated = "PRODUCT_QUANTITY_UPDATED",
  ProductQuantityRunOut = "PRODUCT_QUANTITY_RUN_OUT",
  ProductQuantityOutOfStock = "PRODUCT_QUANTITY_OUT_OF_STOCK",
  ProductCloned = "PRODUCT_CLONED",
  CampaignRunning = "CAMPAIGN_RUNNING",
  CampaignUpdated = "CAMPAIGN_UPDATED",
  CampaignStopped = "CAMPAIGN_STOPPED",
  VoucherActivated = "VOUCHER_ACTIVATED",
  VoucherDeactivated = "VOUCHER_DEACTIVATED",
  BadgePublished = "BADGE_PUBLISHED",
  RefundCreated = "REFUND_CREATED",
  LPReceived = "LP_RECEIVED",
  LPSpent = "LP_SPENT",
  MBSUpgraded = "MBS_UPGRADED",
}

const Notification: React.FC = () => {
  const {
    notifications,
    onChangeTableNotifications,
    metadataNotifications,
    loadingNotifications,
    handleReadNotification,
    handleReadAllNotifications,
  } = useContext(AppTencentContext);

  const handleTitle = (item: any) => {
    const { content } = item;
    const { message } = content;
    let messageCLone = cloneDeep(message);
    const listKey = _.keys(content).filter(item => item !== "message");
    let res;
    if (listKey.length > 0) {
      res = listKey.reduce((message: string, value: string) => {
        return (message as string)?.replace(
          `:${value}`,
          `<span style="color:#fff ; font-weight: 600">${content[value]}</span>`
        );
      }, messageCLone);
    } else {
      res = message;
    }

    return {
      __html: `<div style="font-size: 14px; color: #ABABB1; cursor: pointer ; font-weight: 400;">${res}</div>`,
    };
  };
  return (
    <>
      <div className="title">
        <div className="notifTitle">Notifications</div>
        <div>
          <PrimaryButton onClick={handleReadAllNotifications}>
            <span className="markAsRead">Mark all as read</span>
          </PrimaryButton>
        </div>
      </div>
      <div
        id="scrollableDiv"
        style={{
          marginBottom: 24,
        }}
      >
        <List
          locale={{
            emptyText: (
              <div>
                <Empty description={<span style={{ color: "white" }}>No data</span>} />
              </div>
            ),
          }}
          dataSource={notifications}
          loading={
            loadingNotifications
              ? {
                  tip: "Loading...",
                }
              : false
          }
          renderItem={(item, idx) => {
            return (
              <List.Item
                key={item?.id}
                onClick={() => handleReadNotification(item)}
                style={item.read_at === undefined || !dayjs(item.read_at).isValid() ? {} : { opacity: 0.6 }}
              >
                <List.Item.Meta
                  title={<div dangerouslySetInnerHTML={handleTitle(item)} />}
                  description={<div className="date">{dayjs(item?.notify_at).format("DD/MM/YYYY HH:mm")}</div>}
                />
                <div>
                  {(item.read_at === undefined || !dayjs(item.read_at).isValid()) && (
                    <Badge key={"blue"} color={"#F4E85B"} />
                  )}
                </div>
              </List.Item>
            );
          }}
        />
      </div>
      <CustomPagination
        defaultCurrent={1}
        current={metadataNotifications?.["x-page"] || 1}
        showSizeChanger
        onChange={onChangeTableNotifications}
        total={metadataNotifications?.["x-total-count"] || 0}
      />
    </>
  );
};

export default Notification;
